import { IFilters } from '../interfaces/filters.interface';
import { IInquiry } from '../interfaces/inquiry.interface';
import { IIntercepted } from '../interfaces/intercept.interface';
import { get, post } from '../utils/fetch';
import { ReservationDetail } from '../interfaces/partner-dependent/inquiry-target';
import { MODE_INQUIRY_API_ERROR, MODE_TARGET_API_ERROR } from '../defines/mode';
import { IRecipient } from '../interfaces/user.interface';

export const InquiryApi = {
  searchInquiries: async (
    filters: IFilters,
  ): Promise<{
    inquiries: IIntercepted<IInquiry>;
    recipients: IRecipient[];
  }> => {
    const searchParams = new URLSearchParams(window.location.search);
    // it works dev-login only
    if (searchParams.get('mode') === MODE_INQUIRY_API_ERROR) {
      throw new Error();
    }

    const url = '/api/inquiries/filters';
    return await post(url, { filters }, 'searchInquiries');
  },

  searchTargets: async (
    serviceId: number,
    serviceAttribute: number,
    partnerId: string,
    targetId: string,
  ): Promise<ReservationDetail> => {
    const searchParams = new URLSearchParams(window.location.search);
    // it works dev-login only
    if (searchParams.get('mode') === MODE_TARGET_API_ERROR) {
      throw new Error();
    }

    const url = `/api/targets/${serviceId}/${serviceAttribute}/${partnerId}/${targetId}`;
    return await get(url, 'searchTargets');
  },

  // for future expansion
  // searchInquiriesCount: async (
  //   filters: IFilters,
  // ): Promise<ISearchInquiriesCountResponse> => {
  //   const url = '/api/inquiries/filters/count';
  //   return await post(url, { filters }, 'searchInquiriesCount');
  // },
};
